// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_pUU","cls2":"ReferenceCard-cls2_4b9 ReferenceCard-cls1_pUU"};